import { render } from "./TableComponent.vue?vue&type=template&id=6a2200a0&scoped=true"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"

import "./TableComponent.vue?vue&type=style&index=0&id=6a2200a0&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2200a0"]])

export default __exports__